import { render, staticRenderFns } from "./CustomerMembersView.vue?vue&type=template&id=1234f52b&scoped=true&"
import script from "./CustomerMembersView.vue?vue&type=script&lang=js&"
export * from "./CustomerMembersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1234f52b",
  null
  
)

export default component.exports